package component

import com.github.quillraven.fleks.*
import com.soywiz.klock.*
import com.soywiz.korge.view.*

class SpriteAnimationComponent (
    var nextAnimation: String = NO_ANIMATION,
    var animationType: AnimationType = AnimationType.LOOPED,
    val animationPrefix: String = "",
    val spriteDisplayTime: TimeSpan = TimeSpan.NIL
) : Component<SpriteAnimationComponent> {
    lateinit var sprite: Sprite

    override fun type() = SpriteAnimationComponent

    companion object : ComponentType<SpriteAnimationComponent>() {
        const val NO_ANIMATION = ""
    }
}
